// extracted by mini-css-extract-plugin
module.exports = {"drawer":"drawer_drawer__3VTsn","drawerOpen":"drawer_drawerOpen__2Qetk","drawHeaderText":"drawer_drawHeaderText__13HZ-","content":"drawer_content__356Uu"};